import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPhoneDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="phone-dynamic-island" maskId="round-filled-radius-0-stroke-1.5-IconPhoneDynamicIsland"><path fillRule="evenodd" clipRule="evenodd" d="M5.75 23C5.33579 23 5 22.6642 5 22.25V1.75C5 1.33579 5.33579 1 5.75 1H18.25C18.6642 1 19 1.33579 19 1.75V22.25C19 22.6642 18.6642 23 18.25 23H5.75ZM10.75 3.49C10.3358 3.49 10 3.82579 10 4.24C10 4.65421 10.3358 4.99 10.75 4.99H13.25C13.6642 4.99 14 4.65421 14 4.24C14 3.82579 13.6642 3.49 13.25 3.49H10.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneDynamicIsland;
